import axiosClient from '../../configs/axios';


class OpningBalanceservice {
  
    async getcylinderinventoryreport(params) {
        try {
            const response = await axiosClient.get(
                `/reports/EmptyCylinderInventory?page=${params.page}&size=${params.size}&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async addOpningBaalncereport(params) {
        try {
            const response = await axiosClient.post(
            `/opening_bal/add?page=${params.page}&size=${params.size}&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    async editdeleteOpningBaalncereport(params) {
        try {
            const response = await axiosClient.put(
                `/opening_bal/ediDelete?page=${params.page}&size=${params.size}&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }


    

    



 








   
    
}

export default new OpningBalanceservice(); 